'use strict';

const $ = require('jquery');
require('magnific-popup');
const isEqual = require('lodash/isEqual');
const orderBy = require('lodash/orderBy');

function controller($scope, $attrs, $timeout, plannerService) {
    const prodSeasonNo = parseInt($attrs.prodSeasonNo, 10);
    const performanceNo = $attrs.performanceNo ? parseInt($attrs.performanceNo, 10) : false;

    const vm = this;

    vm.performances = [];
    vm.loading = true;

    vm.totalCount = 0;
    vm.results = [];
    vm.filters = null;
    vm.ticketCount = 2;
    vm.date_filter = {
        from: null,
        to: null,
    };

    vm.updating = false;

    // Set this to any non-falsey value to hide the production filter
    vm.production = {title: "anything"};

    vm.updateDates = dateRange => {
        vm.date_filter = dateRange;
    }

    vm.init = function () {
        plannerService.getPerformances().then(performances => {
            performances = performances.filter(perf => perf.prod_season_no === prodSeasonNo);

            if (performanceNo) {
                performances = performances.filter(perf => perf.perf_no === performanceNo);
            }

            performances.forEach(perf => {
                perf.badge_classes = [];

                if (perf.flag) {
                    perf.badge_classes.push(`badge--flag-${perf.flag.replace(/\s/g, '-').toLowerCase()}`);
                }
            });

            vm.allPerformances = performances;
            vm.allFilters = plannerService.generateFacets(performances);


            vm.totalCount = performance.length;
            vm.performances = performances;

            updateView(performances);

            // Get a watcher going on keyword input, filters, and order
            $scope.$watch(() => [vm.filters, vm.date_filter], processChanges, true);

        }).finally(() => {
            vm.loading = false;

            $(document).on('click', '.js-type-info', function (e) {
                $.magnificPopup.open({
                    items: {
                        src: e.currentTarget.getAttribute('href'),
                        type: 'inline',
                    }
                });
            });
        });
    }

    function processChanges(newVal, oldVal) {
        if (isEqual(newVal, oldVal) || vm.updating) {
            return false;
        }

        applyFiltering(newVal[0], newVal[1], true);
    }

    function applyFiltering(filters, updateLocation) {
        // Keep track is updating to prevent watch firing
        vm.updating = true;

        // Grab our items to begin with
        let filteredItems = filterEvents(vm.allPerformances);

        // Now, apply filters
        const result = plannerService.applyFilters({
            filters: filters,
            items: filteredItems
        });

        result.items = result.items.filter(perf => {
            if (!vm.date_filter.start || !vm.date_filter.end) {
                return true;
            }
            return vm.date_filter.start < perf.start_date_moment && vm.date_filter.end > perf.start_date_moment;
        });

        // Update view :3
        updateView(result.items, result.facets);
    }

    function filterEvents(filteredEvents)
    {
        if (vm.optionFilter === 1) {
            filteredEvents = orderBy(filteredEvents, function (item) {
                return parseFloat(item.price)
            }, ['desc']);
        }

        if (vm.optionFilter === 2) {
            filteredEvents = orderBy(filteredEvents, function (event) {
                return parseFloat(event.price);
            }, ['asc']);
        }

        return filteredEvents;
    }

    function updateView(items, facets, keyword) {
        // Keep track is updating to prevent watch firing
        vm.updating = true;

        // Update keyword field if there's one in URL but not in field
        if (vm.keyword !== keyword) {
            vm.keyword = keyword;
        }

        // Grab count before grouped
        vm.totalCount = items.length;

        // Sort & assign results
        vm.performances = items;

        // Generate filters!
        vm.filters = plannerService.updateFilters({
            filters: vm.filters || vm.allFilters,
            items: items,
            facets: facets || [],
            keyword: keyword
        });

        // Reset updating flag
        $timeout(function () {
            vm.updating = false;
        });
    }

    return vm;
}

module.exports = [
    '$scope',
    '$attrs',
    '$timeout',
    'plannerService',
    controller
]



// WEBPACK FOOTER //
// ./widgets/controllers/PerformanceList.js